// Copied from apps/admin/src/features/map-view/model/helpers/wheel-zoom-target.ts (PRD #875).
// Leaflet rounds a wheel or pinch step up to `zoomSnap`; with the fractional snap that fitted
// views need, a trackpad pinch moves a quarter level. Wheel steps go back to whole levels.
export function wheelZoomTarget(zoom: number, wheelDelta: number, pxPerLevel: number) {
  const d2 = wheelDelta / (pxPerLevel * 4);
  const levels = Math.ceil((4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2))))) / Math.LN2);
  return wheelDelta > 0 ? Math.floor(zoom + 1e-6) + levels : Math.ceil(zoom - 1e-6) - levels;
}
